import React, { useEffect } from 'react';
import Page from 'components/Layout/Page';
import { BrowserRouter, Route, Routes } from 'react-router-dom';
import { ReactKeycloakProvider } from '@react-keycloak/web';

import 'styles/global.scss';
import 'styles/utils.scss';
import 'styles/variables.css';
import Welcome from 'pages/Welcome';
import ThemeProvider from 'providers/ThemeProvider';

import PrivateRoute from 'components/Routes/PrivateRoute';
import LoginPage from 'pages/Login';
import keycloak, { initOptions } from './keycloak';

const App: React.FC = () => {
  useEffect(() => {
    // eslint-disable-next-line no-console
    console.log(
      `%c Build number: ${process.env.REACT_APP_BUILD_NUMBER} `,
      'background: blue; color: white;',
    );
  }, []);

  return (
    <ReactKeycloakProvider authClient={keycloak} initOptions={initOptions}>
      <ThemeProvider>
        <BrowserRouter>
          <Routes>
            <Route path="/" element={<PrivateRoute Component={Welcome} />} />

            <Route path="/login" element={<LoginPage />} />
            <Route
              path="*"
              element={(
                <Page>
                  <div className="d-flex justify-content-center flex-fill align-items-center">
                    <h1 className="text-white">404</h1>
                  </div>
                </Page>
              )}
            />
          </Routes>
        </BrowserRouter>
      </ThemeProvider>
    </ReactKeycloakProvider>
  );
};

export default App;
